import { Flexbox, Toggle } from '@sede-enterprise/shell-ds-react-framework';
import { AddToChartProps } from '../../../../Types/types';
import { one } from '../../../../constants';

const AddToChart: React.FC<AddToChartProps> = ({ row, getValue, handleToggle }) => {
  const toggleLabel = Number(getValue()) === 0 ? 'No' : 'Yes';
  return (
    <Flexbox justifyContent='space-between'>
      {toggleLabel as string}
      <Toggle
        size='medium'
        data-testid='toggle'
        checked={row.original.ADD_TO_CHART === one}
        onChange={() => handleToggle(row.original)}
      />
    </Flexbox>
  );
};

export default AddToChart;
